import {useContext} from 'react';
import {VerificationCompletedContext} from './context';

export const useVerificationCompleted = () => useContext(VerificationCompletedContext);
